export default "__VITE_ASSET__BMO5Zbcf__"